import { NgModule } from '@angular/core';
import { CommonLibModule } from 'mmmo-mo-common-lib';
import { VoiceChannelEditComponent } from './component/voice-channel/edit/edit.component';
import { VoiceChannelViewComponent } from './component/voice-channel/view/view.component';
import { CommentVoiceComponent } from './component/voice-comment/voice.component';
import { VoiceEditorComponent } from './component/voice-editor/voice-editor.component';
import { VoiceMobilePreviewComponent } from './component/voice-mobile-preview/voice-mobile-preview.component';
import { VoiceModalDetailComponent } from './component/voice-modal-detail/voice-modal-detail.component';
import { VoiceConstraintKeywordEditComponent } from './component/voice-sendconstraint-keyword/edit/edit.component';
import { VoiceConstraintKeywordImportExportComponent } from './component/voice-sendconstraint-keyword/import-export/import-export.component';
import { VoiceConstraintKeywordComponent } from './component/voice-sendconstraint-keyword/voice.component';
import { SendDetailVoiceComponent } from './component/voice-sendDetail/voice.component';
import { VoiceTimelineContentComponent } from './component/voice-timeline-content/voice-timeline-content.component';
import { VoiceTplAuditComponent } from './component/voice-tpl-audit/voice-tpl-audit.component';
import { VoiceTplAutoMatchComponent } from './component/voice-tpl-auto-match/voice-tpl-auto-match.component';
import { VoiceTplDetailComponent } from './component/voice-tpl-detail/voice-tpl-detail.component';
import { VoiceTplEditComponent } from './component/voice-tpl-edit/voice-tpl-edit.component';

// 自定义组件
const COMPONENTS = [
  VoiceEditorComponent,
  VoiceMobilePreviewComponent,
  VoiceModalDetailComponent,
  VoiceTimelineContentComponent,
  VoiceTplAuditComponent,
  VoiceTplAutoMatchComponent,
  VoiceTplDetailComponent,
  VoiceTplEditComponent,
  SendDetailVoiceComponent,
  CommentVoiceComponent,

  // 渠道管理
  VoiceChannelEditComponent,
  VoiceChannelViewComponent,
  // 敏感字管控
  VoiceConstraintKeywordComponent,
  VoiceConstraintKeywordImportExportComponent,
  VoiceConstraintKeywordEditComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonLibModule],
  entryComponents: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class VoiceLibModule {}
